/**
 * @file familyDemographics.js
 * @author Jake Stark
 * @desc Family Demographics report plugin

*/

/**
 * @module familyDemographics 
 * @desc FamilyDemographics report plugin
 */

define('plugins/familyDemographics',["underscore",
        "models", "cardboard/models", "cardboard/collections", "cardboard/util", "cardboard/pluginPieces",
        "text!plugins/templates/familyDemographics_mothersAge_table.html!strip", "text!plugins/templates/familyDemographics_teenMothersAge_table.html!strip", "text!plugins/templates/familyDemographics_mothersEducation_table.html!strip"],
       function (_,
                  ECLDSModels, CardboardModels, CardboardCollections, Util, PluginPieces,
                  mothersAgeTemplate, teenMothersAgeTemplate, mothersEducationTemplate) {

    console.log("MODULE: familyDemographics");

    var exports = {

        // options for the demo cats config. since this is a multi-select
        // report, we have to use a different view object, and tell it not to
        // show grades as categories.
        options: {
            orgDetailPane: false,
            noMapSearch: true,
            noOrgFinderSchool: true,
            orgFinderDistrict: true,
            forcedSummaryFilters: ["FISCAL_YEAR", "RACE_ETHTYPE"],
            definitionsECLDS: true
        },

        // each of these is the configuration that gets passed to a
        // DataBoxPaneView.
        panes: [
            {
                title: "Mother's Age at Child's Birth",
                explanationText: "This chart shows public school kindergartners grouped by mother’s age at child’s birth. Mother’s age is identified in the child’s birth record and is unknown for children born outside of Minnesota.",
                openByDefault: true,
                views: [
                    {
                        type: "template",
                        template: "<h5>{{data.heading}}</h5>",
                        dataSourceName: "data",
                        dataPath: "dataSets.mothersAgeAtChildsBirth"
                    },
                     {
                        type: "template",
                        template: "<button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.children[0].id);'>Export to PDF</button>"   
                    },
                    {
                        // SETUP
                        type: "pie",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.mothersAgeAtChildsBirth",
                        //dataPath: "dataSets.mothersAgeAtChildsBirth",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",

                        // since in this case there's only one dimension, due to
                        // there being only one series to plot, it looks like
                        // this:
                        //	 +---------+
                        //	 | X X X X |
                        //	 +---------+
                        convertDataHashToArray: true,
                        dataDimensions: 1,

                        // DISPLAY
                        unitString: "%",
                        unitDec: 1,
                        showLegend: true,
                        dataLabels: false,
                        disableLegendClick: false,
                     //   tooltipTemplate: "<b>{{momsAge}}</b>",

                        exportToPDF: true,
                        hideContext: true,
                        // SERIES (only one series, this is a simple graph)
                        series: [
                            {
                                valuePath: "percent",
                                displayNamePath: "momsAge",
                           //     colors: ["orange", "purple", "green", "blue1", "yellow"]
                            }
                        ],
                        errorConditions: [PluginPieces.standardErrorCondition]
                    },
                   
                    {
                        type: "template",
                        template: mothersAgeTemplate,
                        dataSourceName: "data",
                        dataSetPath: "dataSets.mothersAgeAtChildsBirth",
                        errorConditions: [PluginPieces.silentStandardErrorCondition]
                    }
                ]
            },
            {
                title: "Teen Mother's Age at Child's Birth",
                explanationText: "This chart shows public school kindergartners grouped by mother’s age at child’s birth, for kindergartners born to teen mothers. Mother’s age is identified in the child’s birth record and is unknown for children born outside of Minnesota. ",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>{{data.heading}}</h5>",
                        dataSourceName: "data",
                        dataPath: "dataSets.teenMothersAgeAtChildsBirth"
                    },
                     {
                        type: "template",
                        template: "<button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.children[0].id);'>Export to PDF</button>"   
                    },
                    {
                        // SETUP
                        type: "pie",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.teenMothersAgeAtChildsBirth",
                        //dataPath: "dataSets.mothersAgeAtChildsBirth",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",

                        // since in this case there's only one dimension, due to
                        // there being only one series to plot, it looks like
                        // this:
                        //	 +---------+
                        //	 | X X X X |
                        //	 +---------+
                        convertDataHashToArray: true,
                        dataDimensions: 1,

                        // DISPLAY
                        unitString: "%",
                        unitDec: 1,
                        showLegend: true,
                        dataLabels: false,
                        disableLegendClick: false,
                        exportToPDF: true,
                        hideContext: true,
                        // SERIES (only one series, this is a simple graph)
                        series: [
                            {
                                valuePath: "percent",
                                displayNamePath: "teenMomsAge",
                            //    colors: ["orange", "purple", "green", "blue1", "yellow"],

                            }
                        ],
                        errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: teenMothersAgeTemplate,
                        dataSourceName: "data",
                        dataSetPath: "dataSets.teenMothersAgeAtChildsBirth",
                        errorConditions: [PluginPieces.silentStandardErrorCondition]
                    }
                ]
            },
            {
                title: "Mother's Education Attainment at Child's Birth ",
                explanationText: "This chart shows public school kindergartners grouped by mother's educational attainment at child's birth. Mother's education is identified in the child's birth record and is unknown for children born outside of Minnesota. ",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>{{data.heading}}</h5>",
                        dataSourceName: "data",
                        dataPath: "dataSets.mothersEducationAtChildsBirth"
                    },
                    {
                        type: "template",
                        template: "<button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.children[0].id);'>Export to PDF</button></p>"   
                    },

                    {
                        // SETUP
                        type: "pie",
                        dataSourceName: "data",
                        dataSetPath: "dataSets.mothersEducationAtChildsBirth",
                        //dataPath: "dataSets.mothersAgeAtChildsBirth",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",

                        // since in this case there's only one dimension, due to
                        // there being only one series to plot, it looks like
                        // this:
                        //	 +---------+
                        //	 | X X X X |
                        //	 +---------+
                        convertDataHashToArray: true,
                        dataDimensions: 1,

                        // DISPLAY
                        unitString: "%",
                        unitDec: 1,
                        showLegend: true,
                        dataLabels: false,
                        disableLegendClick: false,
                       // tooltipTemplate: "<b>{{momsEducation}}</b>",
                        exportToPDF: true,
                        hideContext: true,
                        // SERIES (only one series, this is a simple graph)
                        series: [
                            {
                                valuePath: "percent",
                                displayNamePath: "momsEducation",
                            //    colors: ["orange", "purple", "green", "blue1", "yellow"],

                            }
                        ],
                        errorConditions: [PluginPieces.standardErrorCondition]
                    },
                    {
                        type: "template",
                        template: mothersEducationTemplate,
                        dataSourceName: "data",
                        dataSetPath: "dataSets.mothersEducationAtChildsBirth",
                        errorConditions: [PluginPieces.silentStandardErrorCondition]
                    },

                ]
            },
            {
                title: "For More Information",
                visibleByDefault: true,
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<p> Children attending private child care and early learning programs prior to kindergarten are not included in these counts. Not all children participating in these programs may have attended public kindergarten in Minnesota.</p><h2> Glossary</h2><p><strong> CTSTR</strong>: Counts Too Small To Report – when results are less than 10.<br/><strong> ECE</strong>: Early Care and Education.<br/><strong>Kindergarten Cohort</strong>: A group of children who participated in public kindergarten in a given school year.<br/><strong> No Data Available</strong>: No data is available for the selected criteria.<br/><strong> Race/Ethnicity:</strong><ul style='margin-top: -7px; margin-bottom: -15px;'><li>Federal Race/Ethnicity categories are as reported by the child's education record and align with the federal <a href='https://www.govinfo.gov/content/pkg/FR-1997-10-30/pdf/97-28653.pdf' target='_blank'>Office of Management and Budget’s standards</a>.</li><li>State Race/Ethnicity categories are as follows:<ul style='padding-left: 1em;'><li  style='list-style: circle;'><strong>State (Minnesota) Definition of American Indian</strong>: A person having origins in any of the original peoples of North America and who maintains cultural identification through tribal affiliation or community recognition. Any student or descendant from a North American tribe, regardless of other racial backgrounds.</li><li  style='list-style: circle'><strong>State (Minnesota) Definition of Other Indigenous Peoples</strong>: A student whose only racial or ethnic identification is with the original peoples of Central or South America. A student who meets the federal definition of American Indian or Alaska Native but not the state definition of American Indian, which means they identify only with indigenous peoples from Central and South America.</li><li style='list-style: circle'>State (Minnesota) definitions of race/ethnicity other than American Indian and Other Indigenous Peoples align with federal categories</li></ul></li></ul></p><h2>Selection Criteria Definitions</h2><p><strong> School County</strong>: County of the location of public school of enrollment. <br/><strong>School District</strong>: School district in the state of Minnesota.<br/><strong> School Year</strong>: Period of time that covers July 1 of one year through June 30 of the following.<br/><b>Participated in any program</b>: Child meets program specific requirements to be considered engaged or participating in the target public early care and education program. <br/><b> Child Care Assistance Program</b>: (CCAP) helps make quality child care affordable by providing financial assistance to help families with low incomes pay for child care. <br/><b>Early Childhood Family Education</b>: (ECFE) provides supports for all Minnesota families with children between the ages of birth to kindergarten entrance based on the idea that parents are a child's first and most important teachers.<br/><b> Early Childhood Special Education</b>: (ECSE) provides supports and services to infants, toddlers and preschool children with disabilities and their families. <br/><b>MN District Preschool</b>: Program for children age three to kindergarten entrance with the purpose of preparing children to enter kindergarten.<br/><b> No ECE Data Available</b>: Children attending private child care and early learning programs prior to kindergarten are not included in these counts. </p><p> For more information, open the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde034818&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>ECLDS Data Guide. </a></p>"
                    }
                ]
            }
        ],

        filterSources: {
            orgs: {
                modelType: ECLDSModels.ECLDSOrgList,
                //url: "/data/state.json",
                url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_orgid_parentdemographics.fex",
                noViewParams: true,
                enabled: true
            },
            
            filters: {
                modelType: CardboardModels.FilterProducer,
                filterSources: ["filterForReport"],
                urls: {
                    filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_parentdemographics_EcoDevRegion.fex"
                },
                enabled: true,
                noViewParams: false
            },
            filters2: {
                url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_fiscal_year.fex",
                enabled: true,
                modelType: CardboardModels.FilterData
            },
            filters3: {
                modelType: CardboardModels.FilterProducer,
                filterSources: ["filterForReport"],
   
                urls: {

                    filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_parentdemographics_nbr2.fex"
                },

                enabled: true,
                noViewParams: false
            },

            demographicCategories: {
                modelType: CardboardCollections.DemoCatProducer,
                url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_parentDemographics.fex",
                enabled: true
            }
        },

        dataSources: {
            data: {
                modelType: CardboardModels.Model,
                // url: "/data/mocks/preGradData.json",
                // url: "/data/mocks/preGradData_statewide.json",
                url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_parentDemographics.fex",
                yearPath: "meta.fiscalYear",
                //  defaultParams: {
                //	orgId: 999999000,
                //      COHORTID: 2014
                //	},
                enabled: true,
                errorConditions: [PluginPieces.standardErrorCondition]
                
            }

        }
    };

    return exports;
});
